import { ArrowIcon } from "@/icons";
import { IMenuItemModel } from "@/models";
import { Box, BoxProps } from "@mui/material";
import clsx from "clsx";
import Link from "next/link";

const SidebarTooltip = ({ item, isReverse, ...props }: SidebarTooltipProps) => {
  return (
    <Box
      className={clsx("flex", {
        "flex-col-reverse": isReverse,
        "flex-col": !isReverse,
      })}
      {...props}
    >
      <Box
        className={
          "flex justify-between h-[52px] bg-default-hover h5 text-white items-center gap-3 pr-2"
        }
      >
        {item.name}
        {item.children?.length && (
          <Box
            component="span"
            className={clsx({
              "-rotate-90": !isReverse,
              "rotate-90": isReverse,
            })}
          >
            <ArrowIcon />
          </Box>
        )}
      </Box>

      {item.children?.map((itemChild, indexChild) => {
        return (
          <Box
            className="h6 text-disabled-text px-3 py-2 h-10"
            key={indexChild}
          >
            <Link
              href={itemChild.url}
              className={clsx(
                "w-full block hover:text-white",
                itemChild.isActive && "text-white"
              )}
            >
              {itemChild.name}
            </Link>
          </Box>
        );
      })}
    </Box>
  );
};

export default SidebarTooltip;

type SidebarTooltipProps = BoxProps & {
  item: IMenuItemModel;
  isReverse: boolean;
};
